export default __webpack_public_path__ + "static/media/chain.41e4c264.mp4";